import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-icons-container',
  // This template is generated by script in /scripts/generate-icons.js
  templateUrl: './icons-container.component.html',
  styleUrls: ['./icons-container.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconsContainerComponent {}
